import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';

import Button from 'Common/CustomButtons/Button';
import { loadSubmissionComments } from 'Actions/submission';
import { formatDate } from 'Utils';

@connect(store => ({
    loading: store.submissionData.loading,
    success: store.submissionData.success,
    error: store.submissionData.error,
    comments: store.submissionData.comments,
    filter: store.submissionData.filter
}), dispatch => ({
    loadSubmissionComments: (filter) => dispatch(loadSubmissionComments(filter)),
}))
export default class CommentsList extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        submissionId: PropTypes.number.isRequired,
        loadSubmissionComments: PropTypes.func.isRequired,
        comments: PropTypes.array,
        filter: PropTypes.object,
        showEmptyMsg: PropTypes.bool,
    };

    state = {
        hidden: true
    };

    commentsToShowCount = 3;

    componentDidMount() {
        const { loadSubmissionComments, submissionId, filter } = this.props;
        loadSubmissionComments(filter.merge({
            has: {'submission': {
                where: {'submissions.id': submissionId},
            }}
        }));
    }

    getComments() {
        const { comments } = this.props;
        const { hidden } = this.state;

        return comments.map((comment, index) => {
            return (
                hidden && (index > this.commentsToShowCount - 1) ? null :
                    <div className='comment-wrapper' key={index}>
                        <div className='comment-head'>
                            <span className='comment-author'>{ comment.user.first_name } { comment.user.last_name }</span>
                            <span className='comment-date'>{ formatDate(comment.created_at) }</span>
                        </div>
                        <div className='comment-text'>
                            { comment.comment ? comment.comment.split('\n').map((item, i) => {
                                return item ? <p key={i}>{item}</p> : <br key={i} />;
                            }): '' }
                        </div>
                    </div>
            );
        });
    }

    render () {
        const { comments, showEmptyMsg } = this.props;
        const { hidden } = this.state;

        return (
            <div className='comments-list-wrapper'>
                { comments && comments.length ? this.getComments() : (showEmptyMsg ? <FormattedMessage id={'submission.comments.empty'} /> : '') }
                { comments && comments.length > this.commentsToShowCount &&
                    <Button
                        color="defaultNoBackground"
                        left='true'
                        customClass='button-comments-show-all'
                        onClick={() => this.setState({hidden: !hidden})}
                    >
                        { hidden ? <ExpandMore /> : <ExpandLess /> }
                        <FormattedMessage id={hidden ? 'button.comment.show_all' : 'button.comment.hide_all'} />
                    </Button>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/containers/CommentsList.jsx